import axios from 'axios';

const http = axios.create({ baseURL: '/api/v4', timeout: 20000 });

http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers = { ...cfg.headers, Authorization: `Bearer ${token}` };
  return cfg;
});

function ok(res) {
  if (!res?.data?.ok) throw new Error(res?.data?.error || 'API Fehler');
  return res.data;
}

export const timelineApi = {
  listTimelines: (grow_setup_id) =>
    http.get('/timelines', { params: { grow_setup_id } }).then(ok),
  createTimeline: (data) => http.post('/timelines', data).then(ok),
  getTimeline: (id) => http.get(`/timelines/${id}`).then(ok),
  updateTimeline: (id, data) => http.put(`/timelines/${id}`, data).then(ok),
  deleteTimeline: (id) => http.delete(`/timelines/${id}`).then(ok),

  addBlock: (tid, data) => http.post(`/timelines/${tid}/blocks`, data).then(ok),
  updateBlock: (tid, bid, data) => http.put(`/timelines/${tid}/blocks/${bid}`, data).then(ok),
  deleteBlock: (tid, bid) => http.delete(`/timelines/${tid}/blocks/${bid}`).then(ok),
  reorderBlocks: (tid, order) => http.post(`/timelines/${tid}/blocks/reorder`, order).then(ok),

  listProfiles: (user_id) =>
    http.get('/profiles', { params: { user_id } }).then(ok),
  createProfile: (data) => http.post('/profiles', data).then(ok),
  getProfile: (id) => http.get(`/profiles/${id}`).then(ok),
  updateProfile: (id, data) => http.put(`/profiles/${id}`, data).then(ok),
  deleteProfile: (id) => http.delete(`/profiles/${id}`).then(ok),
  cloneProfile: (id, data) => http.post(`/profiles/${id}/clone`, data).then(ok),

  startTimeline: (id, start_date) => http.post(`/timelines/${id}/start`, { start_date }).then(ok),
  getCurrentPhase: (id) => http.get(`/timelines/${id}/current_phase`).then(ok),
};
